import styles from './BeforeCustomsTable.module.scss';
import cn from 'classnames';
import parse from 'html-react-parser';
import { BeforeProps } from '@containers/DataTable';
import { ErrorResponse } from '@api/Responses/ErrorResponse';
import {
  getApproachingDeadline,
  TApproachingDeadlineResponse,
  TProblematicCustomsParcel
} from '@api/apiClient/problematic';
import { Text, TextSize } from '@components/Text';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

const BeforeCustomsTable = (props: BeforeProps<TProblematicCustomsParcel>) => {
  const { isLoading } = props;

  const { t } = useTranslation();

  const {
    data: dataGetApproachingDeadline,
    isFetching: isFetchingGetApproachingDeadline
  } = useQuery<TApproachingDeadlineResponse, ErrorResponse>({
    queryKey: ['getApproachingDeadline', 'problematicCustoms'],
    queryFn: getApproachingDeadline,
    retry: 1
  });

  if (!isLoading && !isFetchingGetApproachingDeadline) {
    if (dataGetApproachingDeadline && dataGetApproachingDeadline.countCustoms) {
      return (
          <div className={cn(styles.inner, styles.innerRed)}>
            <Text size={TextSize.M}>
              <b className={cn(styles.text, styles.textRed)}>
                {t('problematicParcelsPage.customs.notyReturnsTitle')}
              </b>
            </Text>
            <Text size={TextSize.M}>
            <span className={cn(styles.text, styles.textRed)}>
              <b>
                {dataGetApproachingDeadline.countCustoms}
              </b>{' '}-{' '}
              {parse(t('problematicParcelsPage.customs.notyReturnsText'))}
            </span>
            </Text>
          </div>
      );
    }
  }
  return null;
};

export default BeforeCustomsTable;